/**
 * Miniatura di una riga (ordine o reso) dal join live itemsImages (ProductId -> items),
 * con la stessa priorita' di getProductImage della lista ordini: immagine della variante
 * venduta, poi principale del prodotto, poi quella salvata sulla riga, poi nessuna (null).
 */
export function immagineRiga(riga, itemsImages) {
	const snapshot = (riga && riga.image) || null;
	const pid = riga && riga.ProductId ? riga.ProductId.toString() : '';
	const entry = (itemsImages || []).find(it => it._id && it._id.toString() === pid);
	if (!entry || !entry.images || !entry.images.length) return snapshot;
	if (riga.CatalogId) {
		const cat = riga.CatalogId.toString();
		const variante = entry.images.find(img => (img.variants || []).some(v => v && v.toString() === cat));
		if (variante && variante.sizes && variante.sizes[0] && variante.sizes[0].value) return variante.sizes[0].value;
	}
	const prima = entry.images[0];
	return (prima && prima.sizes && prima.sizes[0] && prima.sizes[0].value) || snapshot;
}

export default immagineRiga;
